<template>
    <div>
        <div class="g-pagination">
            <span :class="{ 'page-opt': true, disabled: prevDisabled }" @click="prevPage">{{lang.prevPage}}</span>
            <span
                v-for="(page, index) in pageList"
                :key="index"
                :class="{ 'page-num': true, active: page.isActive, disabled: page.num === null }"
                @click="goPage(page.num)"
            >
                {{ page.show }}
            </span>
            <span :class="{ 'page-opt': true, disabled: nextDisabled }" @click="nextPage">{{lang.nextPage}}</span>
            <span class="page-go">
                <input v-model="goNum" type="number" :min="1" :max="maxPage">
                <small @click="goPage()">{{lang.pageGo}}</small>
            </span>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';

export default {
    name: 'pagination',
    components: { },
    props: {
        totalPage: Number,
        page: Number,
    },
    data() {
        return {
            lang: getLang(),
            goNum: '',
            curPage: this.$props.page || 1,
            maxPage: this.$props.totalPage || 1,
            pageList: [],
            prevDisabled: true,
            nextDisabled: true,
        };
    },
    watch: {
        page() {
            this.curPage = this.$props.page;
            this.renderPage();
        },
        totalPage() {
            this.maxPage = this.$props.totalPage;
            this.renderPage();
        },
    },
    mounted() {
        this.renderPage();
    },
    methods: {
        renderPage() {
            const pageList = [];
            if (this.curPage > 4) {
                pageList[0] = { num: 1, show: '1', isActive: false };
                pageList[1] = { num: null, show: '...', isActive: false };
                pageList[2] = { num: this.curPage - 2, show: `${this.curPage - 2}`, isActive: false };
                pageList[3] = { num: this.curPage - 1, show: `${this.curPage - 1}`, isActive: false };
            } else {
                for (let i = 1; i < this.curPage; i += 1) {
                    pageList.push({ num: i, show: `${i}`, isActive: false });
                }
            }
            pageList.push({ num: this.curPage, show: `${this.curPage}`, isActive: true });
            if (this.curPage < this.maxPage - 3) {
                pageList.push({ num: this.curPage + 1, show: `${this.curPage + 1}`, isActive: false });
                pageList.push({ num: this.curPage + 2, show: `${this.curPage + 2}`, isActive: false });
                pageList.push({ num: null, show: '...', isActive: false });
                pageList.push({ num: this.maxPage, show: `${this.maxPage}`, isActive: false });
            } else {
                for (let i = this.curPage + 1; i <= this.maxPage; i += 1) {
                    pageList.push({ num: i, show: `${i}`, isActive: false });
                }
            }
            this.pageList = pageList;
            this.prevDisabled = this.curPage < 2;
            this.nextDisabled = this.curPage >= this.maxPage;
        },
        nextPage() {
            if (this.curPage < this.maxPage) {
                this.goPage(this.curPage + 1);
            }
        },
        prevPage() {
            if (this.curPage > 1) {
                this.goPage(this.curPage - 1);
            }
        },
        goPage(num) {
            if (num) {
                this.$emit('pageChange', num);
            } else if (+this.goNum <= this.totalPage && +this.goNum > 0) {
                this.$emit('pageChange', +this.goNum);
            }
        },
    },
};
</script>

<style scoped lang="less">
    .g-pagination {
        position: relative;
        text-align: center;
        span {
            cursor: pointer;
            display: inline-block;
            margin: 0 6px;
            height: 24px;
            padding: 0 7px;
            color: #C1C1C1;
            border: 1px solid #F1F1F1;
            font-size: 12px;
            line-height: 24px;
            &.active {
                color: #C71F4B;
                border: 1px solid #C71F4B;
            }
            &.disabled {
                pointer-events: none;
                cursor: not-allowed;
            }
        }
        .page-go {
            input {
                display: inline-block;
                border: 0;
                background: transparent;
                width: 32px;
                height: 24px;
                line-height: 24px;
                text-align: center;
            }
            small {
                display: inline-block;
                padding-left: 4px;
                height: 12px;
                line-height: 12px;
                border-left: 2px solid #F1F1F1;
            }
        }
    }
</style>
